import isBrowser from './isBrowser';

export function clearBrowserStorage() {
  document.cookie.split(';').forEach((cookie) => {
    document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;`);
  });
  window.localStorage.clear();
}

export function fetchMockSuccess(response: Record<string, any> = {}) {
  return jest.fn(() =>
    Promise.resolve({
      ok: true,
      json: () => Promise.resolve(response),
    }),
  ) as unknown as typeof global.fetch;
}

export function fetchMockFailure() {
  return jest.fn(() =>
    Promise.reject({
      ok: false,
    }),
  ) as unknown as typeof global.fetch;
}

declare global {
  interface Window {
    Cypress?: any;
  }
}

export function isRunningInCypress() {
  if (!isBrowser()) return false;

  return Boolean(window.Cypress);
}
